import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { actionCreators } from 'accountSelection/store';

class HomeContainer extends React.Component {
  componentDidMount = () => {
    const { accounts } = this.props;
    if (accounts === null || accounts.length === 0) {
      this.props.getLinkedAccounts(this.handleRedirect);
    }
  };

  handleRedirect = (accounts) => {
    const activeAccounts =
      accounts && accounts.filter((a) => a.isActive || a.isSuspended);
    if (activeAccounts && activeAccounts.length === 1) {
      const account = activeAccounts[0];
      this.props.history.push(`/CustomerDetails/${account.adfitNo}`);
    } else {
      this.props.history.push('/Accounts');
    }
  };

  render() {
    return null;
  }
}

HomeContainer.propTypes = {
  accounts: PropTypes.array,
};

export default compose(
  withRouter,
  connect(
    (state) => ({
      accounts: state.accountSelection.accounts,
    }),
    {
      getLinkedAccounts: actionCreators.getLinkedAccounts,
    }
  )
)(HomeContainer);
